import { ECourierStatusType } from "../../../Enum/ECourierStatusType"

export function Status({ status }: { status: ECourierStatusType }) {
  const styles = {
    [ECourierStatusType.Online]: "bg-emerald-50 text-emerald-700 ring-2 ring-emerald-600/50",
    [ECourierStatusType.Offline]: "bg-slate-100 text-slate-600 ring-2 ring-slate-500/50",
  }

  const labels = {
    [ECourierStatusType.Online]: "Online",
    [ECourierStatusType.Offline]: "Offline",
  }

  return (
    <span
      className={`inline-flex items-center px-4 py-2 rounded-lg text-xs font-semibold transition ${styles[status]}`}
    >
      <span
        className={`mr-2 h-1.5 w-1.5 rounded-full ${
          status === ECourierStatusType.Online ? "bg-emerald-500" : "bg-slate-400"
        }`}
      />
      {labels[status]}
    </span>
  )
}
